"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDecodableTheme = exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const light_1 = __importDefault(require("./light"));
function ThemeProvider({ scoped, children }) {
    // todo: add a theme switching function to context once dark mode is defined
    return ((0, jsx_runtime_1.jsxs)(styles_1.ThemeProvider, Object.assign({ theme: light_1.default }, { children: [scoped ? (0, jsx_runtime_1.jsx)(material_1.ScopedCssBaseline, {}) : (0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), children] })));
}
exports.ThemeProvider = ThemeProvider;
// The name is a bit verbose, but avoids collisions with the
// dozen `useTheme` imports you can find in various MUI and
// related packages (so your editor can auto-import easily).
function useDecodableTheme() {
    return (0, styles_1.useTheme)();
}
exports.useDecodableTheme = useDecodableTheme;
